/**
 * DEV-only seed data for E2E tests.
 * Accessed via getSeedOrders() which is called from use-online-store.js.
 * In production, import.meta.env.DEV is false → entire module tree-shaken away.
 */

const _today = new Date();
const daysAgo = (n) => new Date(_today - n * 86400000).toISOString();

export const SEEDS = {
  'orders-mixed': [
    { id: 'seed-1', bestellnummer: 'TEST-001', kanal: 'ebay', status: 'Offen',     datum: daysAgo(0), preis: 19.99 },
    { id: 'seed-2', bestellnummer: 'TEST-002', kanal: 'etsy', status: 'Bereit',    datum: daysAgo(1), preis: 34.50 },
    { id: 'seed-3', bestellnummer: 'TEST-003', kanal: 'shop', status: 'Versendet', datum: daysAgo(2), preis: 12.00 },
    { id: 'seed-4', bestellnummer: 'TEST-004', kanal: 'ebay', status: 'Retoure',   datum: daysAgo(3), preis:  8.75 },
  ],
  'orders-with-overdue': [
    { id: 'seed-5', bestellnummer: 'TEST-005', kanal: 'ebay', status: 'Offen',     datum: daysAgo(2), preis: 22.00 },
    { id: 'seed-6', bestellnummer: 'TEST-006', kanal: 'etsy', status: 'Bereit',    datum: daysAgo(1), preis: 15.00 },
  ],
  'orders-empty': [],
  'troedel-mixed': {
    troedelItems: [
      { id: 't-1', name: 'Jeans Jacke',          category: 'Kleidung', price: 25, status: 'verfuegbar' },
      { id: 't-2', name: 'Lernspiel Buchdruck',   category: 'Spielzeug', price: 12, status: 'verfuegbar' },
      { id: 't-3', name: 'Altes Buch',            category: 'Bücher',   price:  5, status: 'reserviert' },
    ],
    marketDays: [
      { date: '2026-05-16', salesCount: 2 },
      { date: '2026-05-15', salesCount: 4 },
      { date: '2026-05-14', salesCount: 5 },
    ],
  },
  'troedel-empty': {
    troedelItems: [],
    marketDays: [],
  },
  // Laufender Markt — macht den Live-Markt-Screen testbar (sonst nie aktiv im Seed-Pfad).
  'troedel-live': {
    troedelItems: [
      { id: 'tl-1', name: 'Tischlampe Messing', category: 'Deko',     price: 15, wish_price: 15, active: true, status: 'verfuegbar' },
      { id: 'tl-2', name: 'Wanduhr Holz',        category: 'Deko',     price: 18, wish_price: 18, active: true, status: 'reserviert' },
      { id: 'tl-3', name: 'Lederjacke Vintage',  category: 'Kleidung', price: 40, wish_price: 40, active: true, status: 'verfuegbar' },
      { id: 'tl-4', name: 'Krimi-Sammlung',      category: 'Bücher',   price: 10, wish_price: 10, active: true, status: 'verfuegbar' },
    ],
    marketDays: [],
    activeSession: {
      id: 'tl-session-1',
      location: 'Flohmarkt Testwiese',
      starts_at: '2026-06-04T09:00:00.000Z',
      ends_at: null,
      metadata: {},
    },
  },
  // Laufender Markt MIT Standgebühr — macht Live-Break-even testbar.
  'troedel-live-fee': {
    troedelItems: [
      { id: 'tl-1', name: 'Tischlampe Messing', category: 'Deko',     price: 15, wish_price: 15, active: true, status: 'verfuegbar' },
      { id: 'tl-2', name: 'Wanduhr Holz',        category: 'Deko',     price: 18, wish_price: 18, active: true, status: 'reserviert' },
      { id: 'tl-3', name: 'Lederjacke Vintage',  category: 'Kleidung', price: 40, wish_price: 40, active: true, status: 'verfuegbar' },
      { id: 'tl-4', name: 'Krimi-Sammlung',      category: 'Bücher',   price: 10, wish_price: 10, active: true, status: 'verfuegbar' },
    ],
    marketDays: [],
    activeSession: {
      id: 'tl-session-fee',
      location: 'Flohmarkt Testwiese',
      starts_at: '2026-06-04T09:00:00.000Z',
      ends_at: null,
      booth_fee: 30,
      metadata: {},
    },
  },
  'troedel-with-sales': {
    troedelItems: [
      { id: 't-1', name: 'Jeans Jacke',          category: 'Kleidung',  price: 25, wish_price: 30, active: true },
      { id: 't-2', name: 'Lernspiel Buchdruck',   category: 'Spielzeug', price: 12, wish_price: 12, active: true },
    ],
    marketDays: [
      {
        id: 'seed-session-1',
        location: 'Frankfurt Sachsenhausen',
        starts_at: '2026-05-16T09:00:00.000Z',
        ends_at:   '2026-05-16T16:00:00.000Z',
        sales_count: 3,
        total_revenue: 39,
        sales: [
          {
            id: 'seed-sale-1', total: 22, is_bundle: false, is_voided: false,
            sold_at: '2026-05-16T10:00:00.000Z',
            sale_items: [{ item_id: 't-1', item_name: 'Jeans Jacke', quantity: 1, unit_price: 22, wish_price: 30 }],
          },
          {
            id: 'seed-sale-2', total: 12, is_bundle: false, is_voided: false,
            sold_at: '2026-05-16T11:00:00.000Z',
            sale_items: [{ item_id: 't-2', item_name: 'Lernspiel Buchdruck', quantity: 1, unit_price: 12, wish_price: 12 }],
          },
          {
            id: 'seed-sale-3', total: 5, is_bundle: false, is_voided: false,
            sold_at: '2026-05-16T12:00:00.000Z',
            sale_items: [{ item_name: 'Altes Buch', quantity: 1, unit_price: 5, wish_price: 5 }],
          },
        ],
      },
    ],
  },
  // Vergangener Markttag MIT Standgebühr + eingebetteten sale_items — testet
  // "Gewinn nach Standgebühr", Markttag-Detail-Werte und die Wunschpreis-Quote.
  'troedel-with-fee': {
    troedelItems: [
      { id: 't-1', name: 'Jeans Jacke',          category: 'Kleidung',  price: 25, wish_price: 30, active: true },
      { id: 't-2', name: 'Lernspiel Buchdruck',   category: 'Spielzeug', price: 12, wish_price: 12, active: true },
    ],
    marketDays: [
      {
        id: 'seed-session-fee',
        location: 'Frankfurt Sachsenhausen',
        starts_at: '2026-05-16T09:00:00.000Z',
        ends_at:   '2026-05-16T16:00:00.000Z',
        booth_fee: 10,
        sales_count: 3,
        total_revenue: 39,
        sales: [
          {
            id: 'seed-fee-sale-1', total: 22, is_bundle: false, is_voided: false,
            sold_at: '2026-05-16T10:00:00.000Z',
            sale_items: [{ item_id: 't-1', item_name: 'Jeans Jacke', quantity: 1, unit_price: 22, wish_price: 30 }],
          },
          {
            id: 'seed-fee-sale-2', total: 12, is_bundle: false, is_voided: false,
            sold_at: '2026-05-16T11:00:00.000Z',
            sale_items: [{ item_id: 't-2', item_name: 'Lernspiel Buchdruck', quantity: 1, unit_price: 12, wish_price: 12 }],
          },
          {
            id: 'seed-fee-sale-3', total: 5, is_bundle: false, is_voided: false,
            sold_at: '2026-05-16T12:00:00.000Z',
            sale_items: [{ item_name: 'Altes Buch', quantity: 1, unit_price: 5, wish_price: 5 }],
          },
        ],
      },
    ],
  },
};

export function getSeed() {
  if (!import.meta.env.DEV) return null;
  if (typeof window === 'undefined') return null;
  const params = new URLSearchParams(window.location.search);
  if (params.get('test') !== '1') return null;
  return params.get('seed') || null;
}

/** Returns true when ?test=1&loading=1 is set — keeps the store in permanent loading state. */
export function getLoadingOverride() {
  if (!import.meta.env.DEV) return false;
  if (typeof window === 'undefined') return false;
  const params = new URLSearchParams(window.location.search);
  return params.get('test') === '1' && params.get('loading') === '1';
}

export function getSeedOrders() {
  const name = getSeed();
  if (!name) return null;
  const seed = SEEDS[name] ?? null;
  return Array.isArray(seed) ? seed : null;
}

export function getSeedTroedelItems() {
  const name = getSeed();
  if (!name) return null;
  const seed = SEEDS[name] ?? null;
  if (!seed || Array.isArray(seed)) return null;
  return seed.troedelItems ?? null;
}

export function getSeedMarketDays() {
  const name = getSeed();
  if (!name) return null;
  const seed = SEEDS[name] ?? null;
  if (!seed || Array.isArray(seed)) return null;
  return seed.marketDays ?? null;
}

export function getSeedActiveSession() {
  const name = getSeed();
  if (!name) return null;
  const seed = SEEDS[name] ?? null;
  if (!seed || Array.isArray(seed)) return null;
  return seed.activeSession ?? null;
}
